module.exports = __webpack_public_path__ + "img/4ec74110f98163cf73f578b92724bab2.jpg";